import { IconButton } from '@mui/material';
import { PersonArmsSpreadIcon } from '@phosphor-icons/react';

import { accessibilityMessages } from '@/lib/accessibility/messages';

interface AccessibilityPreferencesLauncherProps {
  onClick: () => void;
}

// Fixed bottom-right — the first fixed-position element in this app (no
// existing chat widget/cookie banner/back-to-top button to collide with,
// per the site-wide grep that turned up zero `position: fixed` usage
// anywhere in src/). `env(safe-area-inset-*)` keeps it clear of notches/
// home-indicators on mobile; the 48px box plus padding clears the WCAG 2.2
// 24x24 minimum target size with real room to spare.
export function AccessibilityPreferencesLauncher({ onClick }: AccessibilityPreferencesLauncherProps) {
  return (
    <IconButton
      onClick={onClick}
      aria-label={accessibilityMessages.openPanel}
      sx={{
        position: 'fixed',
        zIndex: (theme) => theme.zIndex.speedDial,
        right: 'max(16px, env(safe-area-inset-right))',
        bottom: 'max(16px, env(safe-area-inset-bottom))',
        width: 48,
        height: 48,
        bgcolor: 'background.paper',
        color: 'text.primary',
        boxShadow: 4,
        '&:hover': { bgcolor: 'background.paper', boxShadow: 6 },
      }}
    >
      <PersonArmsSpreadIcon size={24} aria-hidden weight="bold" />
    </IconButton>
  );
}
